import React from "react";

import "./index.scss";

const RightArrowIcon = props => {
  let iconClass = "icon-path";
  if (props.disabled) {
    iconClass = `${iconClass}-disabled`;
  }
  return (
    <svg id="right-arrow" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 5.84 9.707" className="button-right-arrow">
      <rect id="Margin" width="12" height="12" fill="none" />
      <g id="Group_10807" data-name="Group 10807">
        <path
          disabled={props.disabled}
          id="Path_8647"
          data-name="Path 8647"
          className={iconClass}
          d="M14,19.107l3.868-3.867L14,11.372l.633-.632,4.5,4.5-4.5,4.5Z"
          transform="translate(-13.646 -10.386)"
        />
      </g>
    </svg>
  );
};

export default RightArrowIcon;
